import data from "../../.sourceflow/employers.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const employer_helper = new CollectionHelper(data);
